export enum AccessFilterType {
    PRIVATE = 'private',
    PUBLIC = 'public',
    ALL = 'all',
}

export interface IFetchStoreParams {
    domain: string;
    storefrontAccessToken: string;
    pageSize?: number;
    query?: string;
    after?: string;
}

export enum StorePlatform {
    Shopify = 'shopify',
    Vogacloset = 'vogacloset',
    Taffi = 'taffi',
    Adidas = 'adidas',
}
